import React from "react";

function NotFound(props) {
  return <div>404 Page Not Found</div>;
}

export default NotFound;
